<script setup>
import { computed } from "vue";

const props = defineProps({
  summary: {
    type: Object,
    default: () => ({}),
  },
});

const total = computed(() =>
  Object.values(props.summary || {}).reduce((sum, value) => sum + value, 0),
);

const summaryItems = computed(() => [
  {
    label: "1 - 30 วัน",
    amount: props.summary["1_30"] || 0,
    progressClass: "bg-warning",
  },
  {
    label: "31 - 60 วัน",
    amount: props.summary["31_60"] || 0,
    progressClass: "bg-danger",
  },
  {
    label: "61 - 90 วัน",
    amount: props.summary["61_90"] || 0,
    progressClass: "bg-danger",
  },
  {
    label: "มากกว่า 90 วัน",
    amount: props.summary["90_plus"] || 0,
    progressClass: "bg-dark",
  },
]);

const getPercent = (amount) => {
  if (!total.value) return 0;
  return Math.round((amount / total.value) * 100);
};

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value || 0);
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5 class="fw-bold mb-1">สรุปยอดตามอายุหนี้</h5>
          <div class="text-muted small">
            แยกยอดค้างชำระตามช่วงอายุหนี้เพื่อใช้ติดตาม
          </div>
        </div>
        <i class="bi bi-bar-chart-line text-primary fs-4"></i>
      </div>

      <div class="vstack gap-3">
        <div v-for="item in summaryItems" :key="item.label">
          <div class="d-flex justify-content-between small mb-1">
            <span class="fw-semibold">{{ item.label }}</span>
            <span class="text-muted">{{ formatCurrency(item.amount) }}</span>
          </div>
          <div class="progress rounded-pill" style="height: 10px">
            <div
              class="progress-bar"
              :class="item.progressClass"
              :style="{ width: `${getPercent(item.amount)}%` }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
